<template>
	<div class="visadetail">
		<back-to></back-to>
		<!-- 轮播 -->
		<section class="visadetailSwiper">
			<van-swipe class="visadetailSwiper-swiper-bg" :loop="false" indicator-color="white">
				<van-swipe-item v-for="(item, index) in swiperLists" :key="index">
					<img v-lazy="item.picturePath" />
				</van-swipe-item>
			</van-swipe>
		</section>
		<!-- 信息 -->
		<section class="visadetail-info">
			<h2>{{productList.title}}</h2>
			<div class="visadetail-info_price">
				<span class="info_pricel">
					<label class="info_pricelp" for="">
						<p>￥</p>
						{{productList.refPrice}}
						<font>起</font>
					</label>
					<!-- <label class="info_pricelm" for="" @click="show = true">起价说明</label> -->
				</span>
				<span class="info_pricer">
					<label for="">签证</label>
					<!-- <label for="">{{productList.mdd}}</label> -->
				</span>
			</div>
			<div class="visadetail-info_serve">
				<!-- <span class="info_serve-title">{{productList.JXPrice}}</span> -->
				<span class="info_serve-tro">
					<label for="">
						<p>编号</p>
						<font>{{id}}</font>
					</label>
					<label for="">
						<p>签证类型</p>
						<font>{{productList.strengths[0].strength}}</font>
					</label>
					<label for="">
						<p>送签地</p>
						<font>{{productList.pods}}</font>
					</label>
					<label for="">
						<p>签证有效期</p>
						<font>{{productList.strengths[1].strength}}</font>
					</label>
					<label for="" v-if="productList.strengths[2]">
						<p>入境次数</p>
						<font>{{productList.strengths[2].strength}}</font>
					</label>
					<label for="" v-if="productList.strengths[3]">
						<p>可停留天数</p>
						<font>{{productList.strengths[3].strength}}</font>
					</label>
				</span>
			</div>
		</section>
		<section class="visadetail-sticky">
			<!-- <van-tabs v-model="active" scrollspy sticky offset-top="46" color="#fbb03b">
				<van-tab title="签证信息" class="visadetail-common">
				</van-tab>
			</van-tabs> -->
			<div class="probably-t">签证信息</div>
			<span class="visadetail-text" v-html="productList.mark"></span>
		</section>
		<!-- 购买按钮 -->
		<section class="detailBottom">
			<a href="tel:02425836666">咨询</a>
			<span class=""
				@click="$router.push({ path: '/groupPackage',query:{'id':id,'packegeSelectIndex':0,'dateSelectIndex':0}})">选择购买</span>
		</section>

	</div>
</template>

<script>
	import BackTo from "@/components/BackTo";
	export default {
		name: 'yongDetail',
		components: {
			BackTo
		},
		data() {
			return {
				productList: [],
				swiperLists: [],
				id: 1,
			}
		},
		created() {
			this.id = this.$route.query.id
		},
		mounted() {
			this.getData()
		},
		methods: {
			scrollTo() {
				window.scrollTo(0, 0)
			},
			getData() {
				this.$_post(
					this.$connectHttpDayun + '/team/api/teamgetfxwd', {
						id: this.id,
						packagecompany: "," + this.$platformid + ","
					}
				).then(res => {
					console.log(res)
					res.object.pods = res.object.pods.map(item => (item.pod)).join("、")
					this.productList = res.object
					this.swiperLists = res.object.pepeatpic
					// this.visa = res.visa[0]
					// this.cppl = res.cppl
				})
			}

		}
	}
</script>

<style>
	.visadetailSwiper,
	.visadetailSwiper-swiper-bg {
		width: 100%;
		height: 500px;
		z-index: -1
	}

	.visadetailSwiper-swiper-bg img {
		width: 100%;
		height: 100%;
		object-fit: fill;
	}

	.visadetail-info {
		width: 100%;
		padding: 20px 30px;
		box-sizing: border-box;
	}

	.visadetail-info h2 {
		font-size: 32px;
		color: #000;
		font-weight: 600;
		padding: 0 14px;
		box-sizing: border-box;
	}

	.visadetail-info_price {
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin-top: 30px;
		padding: 0 14px;
		box-sizing: border-box;
	}

	.info_pricel {
		display: flex;
		align-items: baseline;
	}

	.info_pricelp {
		font-size: 42px;
		color: #ff6d00;
		display: flex;
		align-items: baseline;
	}

	.info_pricelp p {
		padding-right: 10px;
		font-size: 26px;
	}

	.info_pricelp font {
		font-size: 24px;
		padding-right: 26px;
		padding-left: 8px;
	}

	.info_pricelm {
		font-size: 24px;
		color: #345e6d;
	}

	.info_pricer label {
		width: 112px;
		height: 34px;
		padding: 0 3px;
		text-align: center;
		color: #fff;
		font-size: 24px;
		display: inline-block;
	}

	.info_pricer label:first-child {
		background: rgba(254, 109, 2, 1);
		border-bottom-left-radius: 9px;
		border-top-left-radius: 9px;
	}

	.info_pricer label:last-child {
		background: rgba(102, 44, 144, 1);
		border-bottom-right-radius: 9px;
		border-top-right-radius: 9px;
	}

	.visadetail-info_serve {
		width: 100%;
		margin-top: 24px;
	}

	.info_serve-title {
		border-top-right-radius: 8px;
		border-top-left-radius: 8px;
		background: #fff6f0;
		color: #808080;
		font-size: 22px;
		display: block;
		padding: 20px;
		box-sizing: border-box;
	}

	.info_serve-tro {
		width: 100%;
		border-bottom: 6px solid #ff6d00;
		border-top: 2px solid #ececec;
		border-left: 2px solid #ececec;
		border-right: 2px solid #ececec;
		display: flex;
		flex-wrap: wrap;
		box-sizing: border-box;
		padding: 20px 0;
	}

	.info_serve-tro label {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: flex-start;
		width: 33.33%;
		padding: 20px 0;
	}

	.info_serve-tro p {
		color: #ff6c00;
		font-size: 24px;
	}

	.info_serve-tro font {
		color: #000;
		font-size: 26px;
		padding-top: 14px;
		text-align: center;
	}

	.visadetail-sticky .van-tabs__nav {
		background-color: #d3d5dd !important;
		box-shadow: 0 3px 9px 1px rgba(0, 0, 0, 0.4) inset !important;

	}

	.visadetail-sticky .van-tab {
		color: #ffffff !important;
		z-index: 2;
	}

	.visadetail-sticky .van-tabs__line {
		width: 140px;
		height: 50px;
		bottom: 48px;
	}

	.wrapper-cailiao .van-tabs__nav {
		background-color: #d3d5dd;
	}

	.wrapper-cailiao .van-tabs__line {
		border-radius: 10px;
		border: 1px solid #ff6c00;
		background: rgba(252, 234, 222, 0.6) url(https://m.sweetour.com/img/public/ok.png) no-repeat right bottom;
		background-size: 20px 20px;
		width: 140px;
		height: 50px;
		bottom: 48px;
	}

	.wrapper-cailiao .van-tab {
		z-index: 2;
	}

	.visadetail-sticky {
		width: 100%;
		padding-bottom: 200px;
	}

	.visadetail-common {
		padding: 0 30px;
		box-sizing: border-box;
		width: 100%;
	}

	.visadetail-material {
		width: 100%;
		padding: 20px;
		box-sizing: border-box;
	}

	.visadetail-visa {
		width: 100%;
		background-color: #f6f6f6;
		padding: 20px;
		box-sizing: border-box;
		margin-bottom: 60px;
	}

	.visadetail-visa_title {
		height: 48px;
		line-height: 40px;
		font-size: 36px;
		display: flex;
		align-items: center;
		color: #000;
		font-weight: bold;
	}

	.visadetail-visa_title img {
		width: 36px;
		height: 36px;
		padding-right: 14px;
	}

	.visadetail-visa_list {
		width: 100%;
	}

	.visadetail-visa_list label {
		display: flex;
		align-items: flex-start;
		justify-content: space-between;
		color: #666;
		font-size: 28px;
		margin-top: 20px;
	}

	.visadetail-visa_list font {
		color: #333;
		width: 25%;
		font-weight: 600;
	}

	.visadetail-visa_list p {
		width: 65%;
	}

	.line {
		width: 100%;
		height: 20px;
		background-color: #f6f6f6;
	}

	.visadetail-materialc {
		width: 100%;
		margin-top: 30px;
		display: inline-block;
	}

	.visadetail-materialc label {
		width: 96%;
		text-align: center;
		height: 66px;
		background: #f8f8f8;
		font-size: 28px;
		line-height: 66px;
		margin: 0 auto;
		margin-bottom: 20px;
		display: block;
	}

	.visadetail-materialp {
		width: 100%;
		height: 125px;
	}

	.visadetail-materialp-item {
		text-align: center;
		color: #fff;
		width: 125px !important;
		height: 125px;
		background: #ff8a00;
		line-height: 125px;
		margin-right: 30px;
	}

	.visadetail-text {
		padding-top: 10px;
		display: block;
		font-size: 28px;
		line-height: 48px;
		padding-bottom: 30px;
	}

	.pjz {
		height: 64px;
		width: 100%;
		line-height: 64px;
		background: #f8f8f8;
		padding-left: 20px;
		box-sizing: border-box;
		display: block;
		margin-top: 30px;
		margin-bottom: 30px;
	}

	.visadetail-Rate img {
		width: 72px;
		height: 72px;
		border-radius: 72px;
		margin-right: 14px;
	}

	.visadetail-Rate li {
		width: 100%;
		padding: 20px 0;
		box-sizing: border-box;
		border-bottom: 1px dotted #cecece;
	}

	.visadetail-Ratet {
		display: flex;
		justify-content: space-between;
	}

	.visadetail-Rateb {
		font-size: 24px;
		color: #000;
		line-height: 35px;
		text-indent: 50px;
	}

	.visadetail-Ratetr {
		font-size: 18px;
		color: #333;
	}

	.visadetail-Ratetl {
		display: flex;
		align-items: center;
		font-size: 18px;
		color: #000;
		padding-bottom: 20px;
		height: 72px;
		justify-content: space-between;
	}

	.visadetail-see {
		height: 60px;
		width: 220px;
		font-size: 28px;
		color: #fbb03b;
		border: 2px solid #fbb03b;
		text-align: center;
		line-height: 60px;
		margin: 50px auto 0;
		display: block;
	}

	.wrapper-cailiao {
		width: 100%;
		position: fixed;
		bottom: 0;
		left: 0;
		background-color: #fff;
	}

	.wrapper-cailiao h2 {
		height: 95px;
		line-height: 95px;
		font-size: 34px;
		text-align: center;
		color: #000;
	}

	.wrapper-cailiao_con {
		width: 90%;
		overflow-y: scroll;
		margin: 0 auto;
		height: 600px;
		padding-bottom: 30px;
	}

	.wrapper-cailiao_con label {
		display: flex;
		align-items: center;
		height: 75px;
		width: 100%;
		background: #f8f8f8;
		margin-top: 15px;
	}

	.wrapper-cailiao_con h3 {
		font-size: 32px;
		color: #333;
		font-weight: normal;
		padding-left: 20px;
		box-sizing: border-box;
	}

	.wrapper-cailiao_con font {
		height: 50px;
		border: 1px solid #ff8a00;
		margin-left: 15px;
		font-size: 22px;
		line-height: 50px;
		border-radius: 10px;
		text-align: center;
		color: #ff8a00;
		padding: 0 10px;
		box-sizing: border-box;
	}

	.wrapper-cailiao_con p {
		margin-top: 15px;
		margin-bottom: 15px;
		font-size: 26px;
		line-height: 48px;
	}

	.probably-t {
		height: 80px;
		line-height: 80px;
		font-size: 30px;
		color: #ffffff;
		background-color: #d3d5dd;
		padding-left: 30px;
		box-sizing: border-box;
		/* box-shadow: 0 3px 9px 1px rgba(0, 0, 0, 0.4) inset; */
	}
</style>